import React from "react";
import { PageHeader } from "@finitless/shared/components";
import {
  MetricCardSkeleton,
  PopularItemsSkeleton,
  OrderRowSkeleton,
  CustomerSatisfactionSkeleton,
  FilterSkeleton,
} from "../../Skeletons";
import "../states.css";

/**
 * Centralized loading state component for OverviewPage
 * @param {Object} props - Component props
 * @param {Object} props.selectedBrand - Selected brand for header
 * @param {string} props.welcomeMessage - Welcome message to display
 * @param {number} props.cardCount - Number of loading cards to show (default: 6)
 */
const LoadingState = ({ selectedBrand, welcomeMessage, cardCount = 6 }) => {
  return (
    <div aria-busy="true" className="ui-state-surface">
      <PageHeader title="Overview" selectedBrand={selectedBrand}>
        <p className="ui-state-muted text-lg">{welcomeMessage}</p>
      </PageHeader>

      {/* Lapse Filter Skeleton */}
      <FilterSkeleton />

      {/* Metrics Grid */}
      <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 lg:gap-4">
        {Array.from({ length: cardCount }).map((_, index) => (
          <MetricCardSkeleton key={index} />
        ))}
      </div>

      {/* Popular Items Skeleton */}
      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-1">
        <PopularItemsSkeleton titleWidth="w-48" itemCount={5} />
      </div>

      {/* Popular Categories Skeleton */}
      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-1">
        <PopularItemsSkeleton titleWidth="w-56" itemCount={4} />
      </div>

      {/* Recent Orders and Customer Satisfaction Skeleton */}
      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* Recent Orders Skeleton */}
        <div className="bg-card border-border rounded-lg border">
          <div className="border-border border-b p-6">
            <div className="flex items-center justify-between">
              <div className="ui-state-motion bg-muted h-6 w-32 animate-pulse rounded"></div>
              <div className="ui-state-motion bg-muted h-4 w-16 animate-pulse rounded"></div>
            </div>
          </div>
          <div className="divide-border divide-y">
            {Array.from({ length: 5 }).map((_, index) => (
              <OrderRowSkeleton key={index} />
            ))}
          </div>
        </div>

        {/* Customer Satisfaction Skeleton */}
        <CustomerSatisfactionSkeleton />
      </div>
    </div>
  );
};

export { LoadingState };
